import React from "react";
import Swal from "sweetalert2";
import courseService from "../../../../services/course.service";

const DeleteCourse = (props: any) => {
  const { course } = props;
  const onDelete = () => {
    Swal.fire({
      title: "คุณต้องการลบ?",
      text: `รายวิชา (${course.courseCode}) ${course.name} !`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "ใช่",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log("ใช้ต้องการลบเดียวนี้");
        courseService.deleteCourse(course.id).then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "บันทึกสำเร็จ",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            window.location.reload();
          });
        });
      }
    });
  };
  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-danger text-white ms-1"
        onClick={onDelete}
      >
        <i className="bi bi-trash3"></i> ลบ
      </button>
    </>
  );
};

export default DeleteCourse;
